(function syncPointerMode() {
  const apply = () => {
    let hasMouse = false;
    try {
      hasMouse = window.matchMedia('(any-pointer: fine)').matches;
    } catch (e) {
      hasMouse = false;
    }
    document.documentElement.classList.toggle('smk-has-mouse', hasMouse);
    document.documentElement.classList.toggle('smk-touch-only', !hasMouse);
  };
  apply();
  try {
    const mq = window.matchMedia('(any-pointer: fine)');
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  } catch (e) {}
})();

if (!customElements.get('card-bounty-swipe')) {
  customElements.define(
    'card-bounty-swipe',
    class CardBountySwipe extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-bounty-scroller]');
        this.dots = this.querySelectorAll('[data-bounty-dot]');
        if (!this.scroller || !this.dots.length) return;

        this._startX = 0;
        this._startScroll = 0;
        this._moved = false;

        this.onScroll = () => this.syncDots();
        this.onPointerDown = (event) => {
          this._startX = event.clientX;
          this._startScroll = this.scroller.scrollLeft;
          this._moved = false;
        };
        this.onPointerMove = (event) => {
          if (Math.abs(event.clientX - this._startX) > 10) this._moved = true;
        };
        this.onClickCapture = (event) => {
          const scrolled = Math.abs(this.scroller.scrollLeft - this._startScroll) > 6;
          if (this._moved || scrolled) {
            event.preventDefault();
            event.stopPropagation();
          }
        };
        this.onResize = () => this.syncDots();

        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroller.addEventListener('scrollend', this.onScroll, { passive: true });
        this.scroller.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.scroller.addEventListener('pointermove', this.onPointerMove, { passive: true });
        this.scroller.addEventListener('click', this.onClickCapture, true);
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('orientationchange', this.onResize, { passive: true });
        this.syncDots();
      }

      disconnectedCallback() {
        if (!this.scroller) return;
        this.scroller.removeEventListener('scroll', this.onScroll);
        this.scroller.removeEventListener('scrollend', this.onScroll);
        this.scroller.removeEventListener('pointerdown', this.onPointerDown);
        this.scroller.removeEventListener('pointermove', this.onPointerMove);
        this.scroller.removeEventListener('click', this.onClickCapture, true);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('orientationchange', this.onResize);
      }

      syncDots() {
        const width = this.scroller.clientWidth || this.scroller.offsetWidth || 1;
        const left = this.scroller.scrollLeft || 0;
        const index = Math.max(
          0,
          Math.min(this.dots.length - 1, Math.round(left / width))
        );
        this.dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
      }
    }
  );
}
